<ax-apple-wallet-button
  [walletResult]="profileWallet$ | async"
  [fileName]="profileId"
></ax-apple-wallet-button>
